<script>
import { VTextField } from 'vuetify/lib'
/**
 * Propage les attributs au composant v-text-field.
 * C'est donc la même utilisation que ce composant, avec la surcouche présente ci-dessous.
 */
export default {
  name: 'AgrialInput',
  extends: VTextField,
  props: {
    outlined: {
      type: Boolean,
      default: true
    }
  }
}
</script>
